// Named colour sets for the jk-21 line-illustration system (see
// src/components/SmallCardTonalSplash.vue and VerticalSplash.vue). Each set pairs a card background
// with two line colours, extracted from the reference renders in
// .illo-dump/4. Lines for splash cleaned/Colour_examples/. Every value
// points at an existing --color-card-* custom property so a set stays in
// sync with the token layer (dark mode included) rather than hard-coding hex.
export const ILLUSTRATION_COLOURS = {
  pink: {
    background: 'var(--color-card-pink)',
    colour1: 'var(--color-card-orange)',
    colour2: 'var(--color-card-blue)',
  },
  lime: {
    background: 'var(--color-card-lime)',
    colour1: 'var(--color-card-blue)',
    colour2: 'var(--color-card-orange)',
  },
  purple: {
    background: 'var(--color-card-purple)',
    colour1: 'var(--color-card-cyan)',
    colour2: 'var(--color-card-pink)',
  },
  green: {
    background: 'var(--color-card-green)',
    colour1: 'var(--color-card-cyan)',
    colour2: 'var(--color-card-lime)',
  },
  orange: {
    background: 'var(--color-card-orange)',
    colour1: 'var(--color-card-cyan)',
    colour2: 'var(--color-card-yellow)',
  },
  cyan: {
    background: 'var(--color-card-cyan)',
    colour1: 'var(--color-card-blue)',
    colour2: 'var(--color-card-orange)',
  },
  navy: {
    background: 'var(--color-card-navy)',
    colour1: 'var(--color-card-cyan)',
    colour2: 'var(--color-card-pink)',
  },
}
